import axios from 'axios' 
import { BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarAgrugadoDisponibilidadeVeiculo (empredaId) {

  let url = `${URL}/disponibilidade-veiculo/empresa/${empredaId}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO,
        payload: response

      })
  );
}
